<template>
    <div class="display-creative">
        <template v-if="creative.creative_type == 2">
            <div class="creative-text" v-html="creative.text"></div>
        </template>
        <display-media v-else :media="creative.media" :height="height" :width="width" @load="onLoad"></display-media>
        <div class="creative-description m-2" v-if="creative.description">
            {{ creative.description }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        creative: {
            required: true,
        },
        height: {
            default: null,
        },
        width: {
            default: null,
        },
    },
    methods: {
        onLoad(payload) {
            this.$dispatch('load', payload);
        },
    },
};
</script>
